import NavSidebarToggleState from "@/constants/NavSidebarToggleState";

const _state = {
	userSettingOpened: false,
	toggleState: NavSidebarToggleState.UNTOGGLED,
};

const _getters = {
	userSettingOpened: state => state.userSettingOpened,
	toggleState: state => state.toggleState,
};

const mutations = {
	userSettingOpened( state, val ) {
		state.userSettingOpened = val;
	},
	menuActivated( state, menuKey ) {
		state.activeMenuKey = menuKey;
	},
	sidebarToggled( state, toggleState ) {
		state.toggleState = toggleState;
	},
};

const actions = {
	toggleUserSettings: ( { commit, }, { isOpen, } ) => {
		commit( "userSettingOpened", isOpen );
	},
	toggleSidebar( { commit, }, { toggleState, } ) {
		commit( "sidebarToggled", toggleState );
	},
	openNavSidebar( { commit, } ) {
		commit( "sidebarToggled", NavSidebarToggleState.OPEN );
	},
	closeNavSidebar( { commit, } ) {
		commit( "sidebarToggled", NavSidebarToggleState.CLOSED );
	},
	navigateToMyActionItemsPage() {
		window.location.assign( "/t2/action-items" );
	},
	navigateToOneOnOnesPage() {
		window.location.assign( "/t2/one-on-ones" );
	},
	navigateToOneOnOnePage( context, { teamId, } ) {
		window.location.assign( `/t2/one-on-one/${ teamId }/` );
	},
	navigateToTeamsPage() {
		window.location.assign( "/t2/teams" );
	},
	navigateToTeamPage( context, { teamId, } ) {
		window.location.assign( `/t2/team/${ teamId }/` );
	},
};

export default {
	state: _state,
	getters: _getters,
	actions,
	mutations,
	namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/index.js